<template>
    <div>
        <!--        <van-image fit="cover" :src="require('@/assets/inviteBg.png')" style="position: fixed; top: 0; bottom: 0; left: 0; right:0; background-color: white;  z-index: -1;"/>-->
        <!--        <div style="margin: 100px auto 0 auto; width: 272px; display: flex; flex-direction: column;  align-items: flex-end;">-->
        <!--            <div style="display: flex; align-items: center;">-->
        <!--                <span style="color: #333333; font-size: 45px;">益宝计划</span>-->
        <!--                <span style="color: white; font-size: 30px; background-color: #FF3E3E;">邀请卡</span>-->
        <!--            </div>-->
        <!--            <div style="font-size: 14px;">-->
        <!--                <span style="color: #333333;">{{user.userName}}</span>-->
        <!--                <span style="color: #666666; margin-left: 5px;">邀请您加入益宝</span>-->
        <!--            </div>-->
        <!--        </div>-->
        <!--        <div style="margin-top: 30px; display: flex; flex-direction: column; align-items: center;">-->
        <!--            <div id="qrcode" ref="qrcode" style="margin: 15px"></div>-->
        <!--            <div style="color: #666666; font-size: 14px;">扫描二维码加入益宝</div>-->
        <!--        </div>-->
        <!--        <div style="display: flex; flex-direction: column; align-items: center; padding: 17px 0;  position: fixed; bottom: 20px; left: 0; right: 0;">-->
        <!--            <div style="display: flex; align-items: center;">-->
        <!--                <img src="@/assets/yibao-logo.png" width="18px" height="18px">-->
        <!--                <span style="margin-left: 2px; font-size: 14px; font-weight: bolder; color: #4E4E4E;">益宝·心智宝心智障者专项保险</span>-->
        <!--            </div>-->
        <!--            <div style="font: 10px normal; color: #999999; margin-top: 5px;">星贝保险经纪有限公司-益宝计划</div>-->
        <!--        </div>-->
        <div id="captureId" class="capture" v-show="firstFlag">
            <div>
                <div style="padding: 30px 30px">
                    <img v-if="type === '0'" :src="require('@/assets/shareimg1.png')" style="border: 10px white solid; margin: 15%;" width="70%"/>
                    <img v-else :src="require('@/assets/shareimg.png')" width="100%"/>
                    <div style="float: right; text-align: right; border-bottom: 1px #333333 dashed; padding: 20px 0;">
                        <div style="font-size: 18px; font-weight: bold;">{{type === '0' ? '《飞翔的发条小鸟》' : '《梵高的橄榄树》'}}</div>
                        <div style="margin-top: 10px;">作画：涵涵（化名） 8周岁</div>
                    </div>
                </div>
            </div>
            <div style="clear:both; padding: 30px 30px 30px 20px; display: flex;">
                <img style="border-radius: 50%; border: 2px white solid;" width="60px" height="60px" :src="user.imageUrl"/>
                <div style="flex: 1; display: flex; flex-direction: column; margin-left: 10px;">
                    <div style="display: flex; align-items: center; justify-content: space-between; height: 60px;">
                        <div style="color: #333333; font-size: 20px; font-weight: bold;">
                            {{user.userName || user.loginName}}
                        </div>
                        <div>邀请您加入</div>
                        <img :src="type === '0' ? require('@/assets/yibao-logo.png') : require('@/assets/shareimg2.png')" width="35%"/>
                    </div>
                    <div style="display: flex">
                        <div style="font-size: 15px;">
                            <span v-if="type === '1'" style="font-weight: bold;">心智宝</span>
                            <span>{{type === '0' ? '益宝计划成立于2014年11月，是中国首家公益人和中低收入人群普惠保险平台。' : '是由益宝计划发起，中国平安承保并理赔，为我国心智障碍人群专项设计的公益保险服务平台。'}}</span>
                        </div>
                        <div style="display: flex; flex-direction: column; align-items: center; padding-left: 10px;">
                            <div id="qrcode" ref="qrcode"
                                 style="padding: 5px; background-color: white; width: 80px; height: 80px;"></div>
                            <div style="font-size: 10px; background-color: rgba(255,69,0,0.68); text-align: center; color: white;">
                                扫描二维码加入
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <img :src="dataURL" alt="" v-show="!firstFlag" width="100%" height="100%">
    </div>
</template>

<script>

    import Vue from 'vue';
    import {Image} from 'vant';
    import QRCode from 'qrcodejs2'
    import Cookies from 'js-cookie'
    import html2canvas from 'html2canvas'

    Vue.use(Image);
    export default {
        name: "InvitationCard",
        data() {
            return {
                type: Cookies.get('type'),
                dataURL: '',
                firstFlag: true,
                user: this.$store.state.user.user,
                shareURL: process.env.VUE_APP_SHARE_URL + '?shareId=' + this.$store.state.user.user.userId + '&type=' + Cookies.get('type')
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.generateQRCode()
                setTimeout(()=>{
                    this.generateImage()
                }, 500)
            })
        },
        methods: {
            generateQRCode() {
                new QRCode('qrcode', {
                    width: 80,
                    height: 80,
                    text: this.shareURL, // 二维码地址
                    colorDark: '#000',
                    colorLight: '#fff'
                })
            },
            generateImage() {
                let canvas =  document.querySelector('#captureId');
                html2canvas(canvas, { useCORS: true, backgroundColor: '#F3F3F3', windowWidth: canvas.scrollWidth,
                    windowHeight: canvas.scrollHeight, imageTimeout: 15000}).then(canvas => {
                    let imgUrl = canvas.toDataURL('image/png');
                    this.dataURL = imgUrl;
                    this.firstFlag = false;
                })
            }
        }
    }
</script>

<style scoped>

</style>
